import React from "react";
import {
  BrowserRouter as Router,
  Routes ,
  Route
} from "react-router-dom";

import Channels from "./library/Channels";
import CategoryList from "./library/CategoryList";
import Posts from "./library/Posts";
import Users from "./pages/Users";
import Roles from "./pages/Roles";

//import ForgotPassword from "./pages/ForgotPassword";
//import ResetPassword from "./pages/ResetPassword";
import Login from "./pages/Login";


const getBasename = () => {
  ///return '/'+process.env.PUBLIC_URL.split('/').pop();
  ///return "/reacteasetolearn";
  return "";
};

function App() {

  return (
    <Router basename={getBasename()} >
      <div>
        {/* A <Switch> looks through its children <Route>s and
            renders the first one that matches the current URL. */}
        <Routes> 

          <Route exact path="/channels" element={<Channels/>} />
          <Route exact path="/category-list" element={<CategoryList/>} />

          <Route exact path="/posts" element={<Posts/>} />
          
          <Route exact path="/roles" element={<Roles/>} />
          <Route exact path="/users" element={<Users/>} />

          {/* 
          <Route exact path="/forgotpassword" element={<ForgotPassword/>} />
          <Route exact path="/resetpassword" element={<ResetPassword/>} />  
          */}

          
          <Route exact path="/login" element={<Login />} />  
          <Route exact path="/" element={<Login />} />  
          
          
        </Routes >
      </div>
    </Router>
  );
}

export default App;
